/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_SummaryInputs */



/**
* | output |
* | --- |
* | "Pricing Summary" |
*
* @param {Embed_Captions_Pricing_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_summary = /** @type {((inputs?: Embed_Captions_Pricing_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resume des tarifs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Preisübersicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riepilogo dei prezzi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сводка цен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resumen de precios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定价概要")
	if (locale === "ja") return /** @type {LocalizedString} */ ("価格概要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल्य निर्धारण सारांश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resumo de preços")
	return /** @type {LocalizedString} */ ("Pricing Summary")
});